import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import React from 'react';
import { numberInputSpec, stringSelectSpec } from '../../lib/editing-configs';

const StickyContainerWrapper = ({
  children,
  stickTo,
  spacing,
  triggeringScrollDepth,
}) => {
  return (
    <StructuredContent noClearFix>
      {{
        type: 'StickyContainer',
        version: '1.0.0',
        props: {
          stickTo,
          spacing,
          children: [
            {
              type: 'ScrollDepthConditional',
              version: '1.0.0',
              props: {
                triggeringScrollDepth,
                children: [children],
              },
            },
          ],
        },
      }}
    </StructuredContent>
  );
};

StickyContainerWrapper.propTypes = {
  children: PropTypes.node,
  stickTo: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  spacing: PropTypes.oneOf(['0', '1', '2', '3', '3-half', '4', '5']),
  triggeringScrollDepth: PropTypes.number,
};

StickyContainerWrapper.defaultProps = {
  children: null,
  stickTo: 'top',
  spacing: '0',
};

StickyContainerWrapper.getEditingConfig = () => {
  return [
    stringSelectSpec(
      'stickTo',
      'Stick To Alignment',
      [
        { label: 'Top', value: 'top' },
        { label: 'Bottom', value: 'bottom' },
        { label: 'Left', value: 'left' },
        { label: 'Right', value: 'right' },
      ],
      {
        help: 'The edge the content within the container will stick to until it is scrolled past in the document',
      }
    ),
    stringSelectSpec(
      'spacing',
      'Spacing',
      [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '3-half', value: '3-half' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
      ],
      {
        help: 'The amount of space between the edge and the content within the container',
      }
    ),
    numberInputSpec(
      'triggeringScrollDepth',
      'Triggering Scroll Depth Percentage',
      {
        help: 'Defaults to 0',
      }
    ),
  ];
};

StickyContainerWrapper.displayName = 'StickyContainerWrapper';

StickyContainerWrapper.isContainer = true;

export default StickyContainerWrapper;
